<script>
    import { TOAST_MESSAGE } from '../stores'
    import GLOBAL from '../globals/GLOBALS'
    import { createEventDispatcher } from "svelte";
    
    const dispatch = createEventDispatcher();
    
    const validateResult = (json) => {
        dispatch('validateResult',{json})
    }

    const loginScreen = 'images/login-screen.jpg';

    let email = ""
    let password = ""

    const handleClick_ok = async () => {
        const data = {"email" : email,"password" : password}
        const URL = GLOBAL.URL
        await fetch(`${URL}/API/login`,{
            method: 'POST',
            body: JSON.stringify(data),
            headers: {"Content-type": "application/json;charset=UTF-8"}
        })
        // Handle success
        .then(response => response.json())  // convert to json
        .then(json => {
                    TOAST_MESSAGE.set(json)
                    validateResult(json)
              })    //print data to console
        .catch(err => console.log('Request Failed', err)); // Catch errors
    }

</script>

<div class="main-container">
    <div class="sub-container d-flex flex-column justify-content-center align-items-center">
        <h1 class="logo">S O F T W A R E&nbsp;&nbsp;D E&nbsp;&nbsp;   C  A R T E R A</h1>
        <h3>Inicio de Sesión</h3>
        <div class="input-container">
            <div class="form-floating mb-2">
                <input  type="email" class="form-control border border-warning" 
                        id="floatingInput"  bind:value={email} 
                        placeholder="email@dominio.com"
                >
                <label for="floatingInput">Email</label>
            </div>
            <div class="form-floating mb-2">
                <input  type="password" class="form-control border border-info" 
                        id="floatingPassword" bind:value={password}
                        placeholder="Password">
                <label for="floatingPassword">Password</label>
            </div>
            <div class="btn-container" on:click={() => handleClick_ok()}>
                <i class="bi bi-arrow-right" ></i>
            </div>
        </div>
    </div>
    <div class="copyright">CONLUS 2021 Copyright © Todos los derechos reservados - Política de privacidad - ¿Quiénes somos? - Contact us / Contacta con nosotros</div>
</div>

<style>
    .main-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        width: 100vw;
        /* The image used */
        background-image: url("/images/morro_difuminado.png");

        /* Full height */
        height: 100vh;

        /* Center and scale the image nicely */
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .input-container {
        display: flex;
        flex-direction: column;
        width: 270px;
    }

    .sub-container {
        width: 100%;
        padding: 30px;
        background-color: #ffffffc2;
    }

    .logo {
        font-size: 3em;
    }

    input {
        /* padding: 10px; */
        /* margin: 3px; */
        border-width: 4px !important;
        border-radius: 10px; 
        text-align: center ;
        
    }

    .form-floating > label {
        width: 100%;
        text-align: center;
        transform-origin:unset;
    }

    .btn-container {
        display: flex;
        justify-content: center;
        align-items: center;
        align-self: center;
        width: 60px;
        height: 60px;
        font-size: 1.5em;
        background-color: #e74c3c;
        color: #fff;
        border-radius: 50%;
        margin-top: 5px;
        cursor: pointer;
        transition: all 250ms;
    }

    .btn-container:hover {
        transform: scale(1.1);
    }

    .copyright {
        position: absolute;
        bottom: 0;
        color: #fff;
    }
</style>